import clsx from 'clsx';
import React from 'react';

import imgMediaKit from 'images/pro/MediaKit.svg';
import imgNTRS from 'images/pro/NTRS.png';
import imgNYTLogo from 'images/pro/New-York-Times-logo.png';
import imgAtBayLogo from 'images/pro/at-bay-logo.png';
import imgEdbLogo from 'images/pro/edb-logo.png';

import {
  CORPORATE_SUBSCRIPTION_FORM_URL,
  MEDIA_KIT_URL,
  PARTNERSHIP_FORM_URL,
} from '../../utils/constants';

const ProOpportunities = () => (
  <div className="tw-px-16 xs:tw-px-48 tw-py-48 md:tw-py-64">
    <div className="max-w-650 md:max-w-1024 tw-px-16 tw-py-24 md:tw-p-48 tw-rounded-10 shadow-pro tw-mx-auto">
      <div className="md:tw-flex tw-justify-center tw-relative">
        <div
          className={clsx(
            'tw-flex tw-flex-col tw-justify-center tw-border-0 tw-border-solid tw-border-grey-20 tw-mx-auto',
            'md:max-w-575 md:tw-border-l md:order-1 md:tw-pl-48 md:tw-mx-0'
          )}
        >
          <p className="text-overline font-meta-bold tw-text-red tw-uppercase tw-m-0">New</p>
          <h3 className="font-meta-serif-medium text-headline-pro-sm text-black tw-m-0 tw-mt-16">
            Brand Partnerships
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black tw-m-0 tw-mt-16">
            The Information has a highly engaged and influential subscriber base of startup
            founders, venture capitalists, and technology decision makers. We offer numerous
            opportunities for brands to share their message with our subscribers.
          </p>
          <div className="tw-absolute tw-bottom-0 md:tw-static tw-flex tw-flex-col md:tw-flex-row tw-gap-x-12 tw-gap-y-24 md:tw-mt-16 tw-w-full">
            <a
              href={`${PARTNERSHIP_FORM_URL}?source=pro_landing_page`}
              className={clsx(
                'text-button font-meta-medium !text-true-white bg-red-dark uppercase',
                'md:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-rounded-r-2',
                'hover:bg-red focus:bg-red transition-colors'
              )}
            >
              Learn More
            </a>
            <a
              href={MEDIA_KIT_URL}
              className={clsx(
                'text-button font-meta-medium text-black uppercase',
                'md:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-gap-x-12 tw-rounded-r-2',
                'hover:text-grey-60 focus:text-grey-60 transition-colors'
              )}
            >
              <img src={imgMediaKit} alt="" />
              View media kit
            </a>
          </div>
        </div>
        <div className="tw-flex md:tw-flex-col tw-justify-center tw-items-center tw-gap-x-48 tw-gap-y-80 tw-shrink-0 tw-w-full md:tw-w-[248px] tw-mx-auto tw-mt-16 tw-pb-[136px] md:tw-m-0 md:tw-py-36 md:tw-pr-48">
          <div className="tw-w-80 tw-h-[30px] md:tw-w-[150px] md:tw-h-[60px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-h-full"
              src={imgEdbLogo}
              alt="EDB Singapore"
            />
          </div>
          <div className="tw-w-80 tw-h-[30px] md:tw-w-[150px] md:tw-h-[60px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-h-full"
              src={imgAtBayLogo}
              alt="At Bay"
            />
          </div>
          <div className="tw-w-80 tw-h-[30px] md:tw-w-[150px] md:tw-h-[60px]">
            <img
              className="tw-block tw-object-contain tw-object-center tw-w-full tw-h-full"
              src={imgNTRS}
              alt="Northern Trust"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="max-w-650 md:max-w-1024 tw-px-16 tw-py-24 md:tw-p-48 tw-rounded-10 shadow-pro tw-mt-32 md:tw-mt-48 tw-mx-auto">
      <div className="md:tw-flex tw-justify-center tw-relative">
        <div
          className={clsx(
            'tw-flex tw-flex-col tw-justify-center tw-border-0 tw-border-b tw-border-solid tw-border-grey-20 tw-mx-auto tw-pb-16',
            'md:max-w-575 md:tw-border-l md:tw-border-b-0 md:order-1 md:tw-pl-48 md:tw-pb-0 md:tw-mx-0'
          )}
        >
          <p className="text-overline font-meta-bold tw-text-red tw-uppercase tw-m-0">
            More opportunities
          </p>
          <h3 className="font-meta-serif-medium text-headline-pro-sm text-black tw-m-0 tw-mt-16">
            Corporate Subscriptions
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black tw-m-0 tw-mt-16">
            Empower your team with deep industry knowledge and networking opportunities with other
            subscribers. The Information corporate subscription packages are available for teams of
            all sizes.
          </p>
          <a
            href={`${CORPORATE_SUBSCRIPTION_FORM_URL}?source=pro_landing_page`}
            className={clsx(
              'tw-absolute tw-bottom-0 md:tw-static text-button font-meta-medium !text-true-white bg-red-dark uppercase',
              'md:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-rounded-r-2 md:tw-mt-16 tw-w-full',
              'hover:bg-red focus:bg-red transition-colors'
            )}
          >
            Learn More
          </a>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-center tw-shrink-0 tw-w-full md:tw-w-[248px] tw-mx-auto tw-pb-72 md:tw-m-0 md:tw-py-36 md:tw-pr-48">
          <p className="font-meta-normal text-paragraph text-black tw-m-0 tw-mt-16 tw-ml-24 md:tw-mx-0">
            <span className="absolute font-meta-medium tw-text-[42px] md:text-72 text-red tw-left-0 translate-y-10 md:tw-left-auto md:-translate-y-16">
              “
            </span>
            The Information{'’'}s reporters have become{' '}
            <span className="font-meta-bold">
              known in Silicon Valley for sniffing out the industry{'’'}s misdeeds and tweaking its
              powerful.”
            </span>
          </p>
          <div className="tw-w-[172px] tw-mt-16 tw-ml-24 md:tw-mt-32 md:tw-mx-0">
            <img
              className="tw-block tw-object-contain tw-w-full"
              src={imgNYTLogo}
              alt="The New York Times"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProOpportunities;
